import React from "react";
import { DeliveryView } from "./DeliveryView";
import {
  CrudlStatus,
  ToggleState,
  PageState
} from "../../common/config/AppConstants";
import { ViewState } from "../../common/config/AppConstants";
import { ValidateState } from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";
import * as format from "../../common/FormatFunctions";

import { LoadScreen } from "../Common/LoadScreen";
import { ErrorScreen } from "../Common/ErrorScreen";

export class DeliveryController extends React.Component {
  state = {
    pageName: "DeliveryController",
    pageState: PageState.IDLE,
    editLoading: true,

    //DISPLAY STATES
    viewState: ViewState.TABLE,

    validateState: ValidateState.NONE,
    crudlState: CrudlStatus.LIST,
    menuState: [],

    // DATA TABLE
    expandedRows: null,
    tableColumns: [],
    columnOptions: [],
    rowCount: 10,
    settingsToggle: ToggleState.OFF,

    // DETAILS
    deliveryList: null,
    originalEditedDelivery: "",
    editedDelivery: null,

    hasOverlays: true
  };

  componentDidMount = async () => {
    this.initialDataRender();
  };

  componentDidCatch = (error, info) => {
    console.log("This went in here");

    //COMPONENT ISSUE CHECK IF THIS ERROR HANDLING IS CORRECT
    this.setError(false, "componentDidCatch", error);
  };

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setError = (critical, methodName, error) => {
    this.props.log.error(error.message);
    if (critical) {
      this.setCriticalError();
    } else {
      this.setStandardError();
    }
    this.props.viewModel.createException(
      error,
      this.state.pageName,
      methodName
    );
  };
  setStandardError = () => {
    //MORE CAN BE ADDED HERE AS APPROPRIATE
    this.showError("Delivery");
    this.setState({ pageState: PageState.IDLE });
  };
  setCriticalError = () => {
    //SET ERROR STATE OF PAGE
    this.setState({ pageState: PageState.ERROR });
  };

  setViewModel = () => {
    try {
      this.props.viewModel.updateState = this.updateState;
      this.props.viewModel.showError = this.showError;
      this.props.viewModel.showSuccess = this.showSuccess;
      this.props.viewModel.showEmpty = this.showEmpty;
    } catch (error) {
      this.setError(false, "setViewModel", error);
    }
  };

  setPageData = async () => {
    try {
      this.setState({ pageState: PageState.LOADING });

      this.menuState(CrudlStatus.LIST);

      this.setUpColumns();
      this.setUpOrderColumns();

      // SPECIFIC API CALLS GO HERE
      await this.props.viewModel.getDeliverys();
      await this.props.viewModel.getOrders();
      await this.props.viewModel.getProducts();

      this.setState({
        pageState: PageState.IDLE
      });
    } catch (error) {
      this.setError(true, "setPageData", error);
    }
  };
  showError = (display, crudlStatus) => {
    try {
      this.props.feedback.showError(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showError", error);
    }
  };
  showSuccess = (display, crudlStatus) => {
    try {
      this.props.feedback.showSuccess(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showSuccess", error);
    }
  };
  showEmpty = display => {
    try {
      this.props.feedback.showEmpty(this.growl, display);
    } catch (error) {
      this.setError(false, "showEmpty", error);
    }
  };

  getStateValuesAsObject = () => {
    try {
      var externalObject = {};
      externalObject.deliveryBean = this.state.editedDelivery;

      return externalObject;
    } catch (error) {
      this.setError(false, "getStateValuesAsObject", error);
    }
  };

  updateBean = async (field, value) => {
    try {
      this.props.log.info(
        "Updating : [" + field + "] with value [" + value + "]"
      );
      await this.setState(prevState => ({
        editedDelivery: {
          // object that we want to update
          ...prevState.editedDelivery, // keep all other key-value pairs
          [field]: value
        }
      }));
    } catch (error) {
      this.setError(false, "updateBean", error);
    }
  };

  updateState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (error) {
      this.setError(false, "updateState", error);
    }
  };

  toggleOverlay = value => {
    try {
      this.props.log.info("Checking Overlays");
      if (this.state.hasOverlays) {
        this.props.log.info("Checking Overlays : true");
        if (format.isFunction(this.props.toggleTopbar)) {
          this.props.log.info("Checking Overlay Function : exists");
          this.props.toggleTopbar(value);
        }
      }
    } catch (error) {
      this.setError(false, "toggleOverlay", error);
    }
  };
  validateChanges = () => {
    try {
      if (this.state.editedDelivery === null) {
        this.discardChanges();
      } else {
        if (
          format.isJsonEqual(
            this.state.originalEditedDelivery,
            this.state.editedDelivery
          )
        ) {
          this.discardChanges();
        } else {
          this.setState({ validateState: ValidateState.CONFIRM });
        }
      }
    } catch (error) {
      this.setError(false, "validateChanges", error);
    }
  };

  discardChanges = () => {
    try {
      this.setState({
        viewState: ViewState.TABLE,
        toggleChangesMade: false,
        crudlState: CrudlStatus.LIST,
        selectedDelivery: null
      });
      this.toggleOverlay(ToggleState.ON);
      this.menuState(CrudlStatus.LIST);
    } catch (error) {
      this.setError(false, "discardChanges", error);
    }
  };

  checkRequiredFields = () => {
    try {
      if (format.isNotNull(this.state.editedDelivery)) {
        // ADD REQUIREDD FIELDS HERE AS APPROPRIATE
        return format.validateValues([this.state.editedDelivery.orderId]);
      } else {
        return true;
      }
    } catch (error) {
      this.setError(false, "checkRequiredFields", error);
    }
  };

  menuState = crudlStatus => {
    try {
      this.setState({
        menuState: pr.getBreadcrumbMenuState(
          crudlStatus,
          "Delivery",
          "#/deliverys"
        )
      });
    } catch (error) {
      this.setError(false, "menuState", error);
    }
  };

  executeCrudl = async stayOnPage => {
    try {
      if (format.isNotNull(this.state.crudlState)) {
        this.props.log.info(
          "Executing " +
            this.state.crudlState.value +
            " Staying[" +
            stayOnPage +
            "]"
        );

        switch (this.state.crudlState) {
          case CrudlStatus.CREATE:
            await this.addDelivery(stayOnPage);
            break;
          case CrudlStatus.UPDATE:
            await this.updateDelivery(stayOnPage);
            break;
          case CrudlStatus.DELETE:
            await this.deleteDelivery();
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeCrudl", error);
    }
  };

  executeSetup = (requiredCrudlState, data) => {
    try {
      if (format.isNotNull(requiredCrudlState)) {
        this.props.log.info("Setting up " + requiredCrudlState.value);
        switch (requiredCrudlState) {
          case CrudlStatus.CREATE:
            this.createSetup();
            break;
          case CrudlStatus.UPDATE:
            this.updateSetup(data);
            break;
          case CrudlStatus.VIEW:
            this.viewSetup(data);
            break;
          case CrudlStatus.DELETE:
            this.deleteSetup(data);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeSetup", error);
    }
  };

  setUpOrderColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(
      pr.getTableColumn("customerDetails.businessName", "Customer")
    );
    localCols.push(pr.getTableColumn("status", "Status"));
    localCols.push(
      pr.getTableColumn("dateOrderReceivedToDisplay", "Date Received")
    );
    this.setState({ orderTableColumns: localCols });
  };

  setUpColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("deliverySequenceNo", "Delivery No"));
    localCols.push(pr.getTableColumn("orderSequenceNo", "Order No"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(
      pr.getTableColumn("customerDetails.businessName", "Customer")
    );
    localCols.push(pr.getTableColumn("status", "Status"));
    localCols.push(pr.getTableColumn("deliveryDateToDisplay", "Delivery Date"));
    this.setState({ tableColumns: localCols });
  };

  columnToggle = event => {
    this.setState({ tableColumns: event.value });
  };

  createSetup = () => {
    window.scrollTo(0, 0);

    var data = {};
    data = this.additionalParseFunctions(data, CrudlStatus.CREATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.CREATE,
      editedDelivery: data,
      originalEditedDelivery: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.CREATE);
  };

  updateSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.UPDATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.UPDATE,
      editedDelivery: data,
      originalEditedDelivery: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.UPDATE);
  };

  viewSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.VIEW);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.VIEW,
      editedDelivery: data,
      originalEditedDelivery: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.VIEW);
  };

  deleteSetup = data => {
    data = this.additionalParseFunctions(data, CrudlStatus.DELETE);

    this.setState({
      crudlState: CrudlStatus.DELETE,
      editedDelivery: data,
      originalEditedDelivery: JSON.stringify(data),
      validateState: ValidateState.DELETE
    });
    this.menuState(CrudlStatus.DELETE);
  };

  additionalParseFunctions = (data, crudlState) => {
    //TODO if required
    switch (crudlState) {
      case CrudlStatus.CREATE:
        break;
      case CrudlStatus.UPDATE || CrudlStatus.VIEW:
        data = this.props.viewModel.parseDeliveryAndItems(
          data,
          this.state.productList,
          this.state.orderList
        );
        break;
      case CrudlStatus.DELETE:
        break;
      default:
        break;
    }
    this.props.log.info(data);
    return data;
  };

  addDelivery = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var deliveryResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (deliveryResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateDeliveryList(
          deliveryResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentDelivery(
          deliveryResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };
  updateDelivery = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var deliveryResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (deliveryResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateDeliveryList(
          deliveryResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentDelivery(
          deliveryResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  deleteDelivery = async () => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var deliveryResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (deliveryResponse.errorCode === 0) {
      await this.updateDeliveryList(
        deliveryResponse,
        CrudlStatus.DELETE,
        stateVariables
      );
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  updateDeliveryList = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    await this.props.viewModel.getDeliverys();

    this.setState({
      viewState: ViewState.TABLE,
      crudlState: CrudlStatus.LIST,
      validateState: ValidateState.NONE,
      editedDelivery: null
    });

    this.toggleOverlay(ToggleState.ON);
    this.menuState(CrudlStatus.LIST);

    this.setState({ pageState: PageState.IDLE });
  };

  updateCurrentDelivery = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    var deliveryList = await this.props.viewModel.getDeliverysReturned();
    var delivery = {};
    if (format.isNotNull(deliveryList)) {
      deliveryList.forEach(element => {
        if (element.id === apiResponse.id) {
          delivery = format.deepCopy(element);
        }
      });
    }
    this.updateSetup(delivery);
    this.setState({ pageState: PageState.IDLE });
  };

  selectOrder = value => {
    try {
      if (format.isNotNull(value)) {
        this.updateState("selectedOrder", format.deepCopy(value));

        var orderItems = this.props.viewModel.parseOrderItems(
          format.deepCopy(value.orderItemResponseList),
          this.state.productList
        );

        var deliverySelected = this.props.viewModel.convertOrderToDelivery(
          format.deepCopy(value),
          this.state.productList
        );

        this.updateState("editedDelivery", deliverySelected);
        this.updateState("selectedOrderItems", orderItems);
      } else {
        this.updateState("selectedOrder", null);
        this.updateState("editedDelivery", {});
        this.updateState("selectedOrderItems", null);
      }
    } catch (error) {
      this.setError(false, "selectOrder", error);
    }
  };

  resetOrderItems = () => {
    try {
      var orderItems = this.state.selectedOrder.orderItemResponseList;

      var parsedOrderItems = this.props.viewModel.parseOrderItems(
        format.deepCopy(orderItems),
        this.state.productList
      );

      this.updateState("selectedOrderItems", parsedOrderItems);
    } catch (error) {
      this.setError(false, "resetOrderItems", error);
    }
  };

  setUpOrderColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("orderSequenceNo", "Order Number"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(
      pr.getTableColumn("customerDetails.businessName", "Customer")
    );
    localCols.push(pr.getTableColumn("status", "Status"));
    localCols.push(
      pr.getTableColumn("dateOrderReceivedToDisplay", "Date Received")
    );
    this.setState({ orderTableColumns: localCols });
  };

  render() {
    return (
      <React.Fragment>
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />

        {/*VERY VERY BAD ERROS ONLY eg PAGE LOAD*/}
        {this.state.pageState === PageState.ERROR && (
          <ErrorScreen
            loading={this.state.pageState === PageState.LOADING}
            refresh={this.setPageData}
          />
        )}

        {this.state.pageState !== PageState.ERROR && (
          <DeliveryView
            //STATE + HELPER VALUES
            viewState={this.state.viewState}
            validateState={this.state.validateState}
            crudlState={this.state.crudlState}
            menuState={this.state.menuState}
            loading={this.state.pageState === PageState.LOADING}
            updateState={this.updateState}
            refresh={this.setPageData}
            //CARD SPECIFIC PROPS
            editedObject={this.state.editedDelivery}
            selectedOrderItems={this.state.selectedOrderItems}
            selectedOrderItemsDialog={this.state.selectedOrderItemsDialog}
            orderList={this.state.orderList}
            productList={this.state.productList}
            orderTableColumns={this.state.orderTableColumns}
            orderExpandedRows={this.state.orderExpandedRows}
            selectOrder={this.selectOrder}
            selectedOrder={this.state.selectedOrder}
            resetOrderItems={this.resetOrderItems}
            deletedDeliveryItemList={this.state.deletedDeliveryItemList}
            deliveryTypeOptions={this.state.deliveryTypeOptions}
            updateEdited={this.updateBean}
            validateChanges={this.validateChanges}
            discardChanges={this.discardChanges}
            checkRequiredFields={this.checkRequiredFields}
            crudlExecute={this.executeCrudl}
            //TABLE SPECIFIC PROPS
            crudlControl={this.executeSetup}
            deliveryList={this.state.deliveryList}
            expandedRows={this.state.expandedRows}
            tableColumns={this.state.tableColumns}
            columnOptions={this.state.columnOptions}
            columnToggle={this.columnToggle}
            tableReference={this.state.tableReference}
            rowCount={this.state.rowCount}
            settingsToggle={this.state.settingsToggle}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Deliverys/DeliveryController.js